import { FeaturesEnum } from '~/features/types';
import { PermissionEnum } from '~/roles/types';

export default [
  {
    path: '/calendar',
    meta: {
      auth: true,
      feature: FeaturesEnum.CALENDAR,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        component: () => import('~/calendar/pages/CalendarLayout.vue'),
        children: [
          {
            path: '',
            name: 'calendar',
            component: () => import('~/calendar/pages/Index.vue'),
          },
          {
            path: 'events',
            name: 'events',
            component: () => import('~/calendar/pages/events/EventsList.vue'),
          },
          {
            path: 'categories',
            name: 'calendarCategories',
            meta: {
              permissions: [PermissionEnum.CALENDAR],
            },
            component: () => import('~/calendar/pages/Categories.vue'),
          },
          {
            path: 'templates',
            name: 'calendarTemplates',
            meta: {
              permissions: [PermissionEnum.CALENDAR],
            },
            component: () => import('~/calendar/pages/Templates.vue'),
          },
          {
            path: 'locations',
            name: 'locations',
            meta: {
              permissions: [PermissionEnum.CALENDAR],
            },
            component: () => import('~/calendar/pages/Locations.vue'),
          },
        ],
      },
    ],
  },
];
